<div class="scanner">
  <div class="scanner-container">
    <ng-container *ngIf="portfolioApi.activePortfolio">
      <app-scanner-main></app-scanner-main>
    </ng-container>
    <div
      class="scanner-message"
      *ngIf="portfolioApi.activePortfolio === undefined"
    >
      <p>CREATE A PORTFOLIO TO START SEEING YOUR INSIGHTS</p>
      <button mat-stroked-button (click)="openPortfolioBoard()">
        CREATE PORTFOLIO
      </button>
    </div>
    <div class="loading" *ngIf="portfolioApi.activePortfolio === null">
      <mat-spinner [diameter]="50"></mat-spinner>
    </div>
  </div>
</div>
